import { render, staticRenderFns } from "./detail-view.vue?vue&type=template&id=37c89284"
import script from "./detail-view.vue?vue&type=script&lang=js"
export * from "./detail-view.vue?vue&type=script&lang=js"
import style0 from "./detail-view.vue?vue&type=style&index=0&id=37c89284&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports